import Link from 'next/link'
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardHeader,
  createStyles,
  makeStyles,
} from '@material-ui/core'
import { formatDistance } from 'date-fns'
import { PlayerLadder } from '../types'
import {
  getLadderUrl,
  getPlayerFullName,
  getPlayerImageUrl,
} from '../utils/player'

const useStyles = makeStyles(({ spacing }) => {
  const squareHeight = {
    height: 'auto',

    '&:after': {
      content: '""',
      display: 'block',
      paddingBottom: '100%',
    },
  }

  return createStyles({
    'player-0': {
      width: '25%',
      ...squareHeight,
    },
    'player-1': {
      margin: spacing(0, 0.5),
      width: '20%',
      ...squareHeight,
    },
    'player-2': {
      margin: spacing(0, 0.5),
      width: '15%',
      ...squareHeight,
    },
    'player-3': {
      margin: spacing(0, 0.25),
      width: '12.5%',
      ...squareHeight,
    },
    'player-4': {
      margin: spacing(0, 0.25),
      position: 'relative',
      width: '10%',
      ...squareHeight,
    },
  })
})

const TIER_TO_PLAYER_CLASS = [
  'player-0',
  'player-1',
  'player-2',
  'player-3',
  'player-4',
] as const

interface Props {
  ladder: PlayerLadder
  url?: string
}

const LadderCard = ({ ladder, url }: Props) => {
  const classes = useStyles()

  return (
    <Card>
      <Link href={url || getLadderUrl(ladder)} passHref>
        <CardActionArea>
          <CardHeader
            title={ladder.title}
            subheader={formatDistance(Date.parse(ladder.modified), Date.now(), {
              addSuffix: true,
            })}
          />
          <Box pb={2}>
            {ladder.tiers.map((tier, index) => (
              <Box key={index} display="flex" justifyContent="center">
                {tier.map((player) => (
                  <Avatar
                    key={player?.id}
                    alt={getPlayerFullName(player)}
                    src={getPlayerImageUrl(player)}
                    variant="rounded"
                    className={classes[TIER_TO_PLAYER_CLASS[index]]}
                  />
                ))}
              </Box>
            ))}
          </Box>
        </CardActionArea>
      </Link>
    </Card>
  )
}

export default LadderCard
